export default __webpack_public_path__ + "37dc18d45caf84ded7fd210c0d8f2848.png";